/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * Banner action size enumeration.
 */
export type BannerSize = typeof BannerSize[keyof typeof BannerSize];


export const BannerSize = {
  large: 'large',
  small: 'small',
} as const;
